import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PersonHasPartExamItem, PersonHasPartExam } from '../models';

export class PersonHasPartExamApi extends ApiModule {
  protected endpoint = '/person-has-part-exam';

  public async pagePersonHasPartExams(params: any) {
    return this.api.post<PaginatedResponseData<PersonHasPartExamItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadPersonHasPartExamDetails(id: number) {
    return this.api.get<PersonHasPartExam>(`${this.endpoint}?id=${id}`);
  }

  public savePersonHasPartExam(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePersonHasPartExam(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
